<template>
  <section class="">
    <div class="road-trip-section" aria-label="Discover one of Alabama's Road Trips." v-if="trips && trips.length > 0">
      <div class="container">
        <div class="row row-plx">
          <div class="col-lg-6 col-sm-12 extra-space">
            <h2 class="heading-text">
              Hit the road, with an <br />
              Alabama Road Trip
            </h2>
            <div class="stack">
              <div class="rt-card" v-for="(trip, index) in trips" :key="index" @click="swap($event)">
                <article :aria-label="trip.title">
                  <div class="image-wrapper" aria-hidden="true">
                    <span class="trip-number">Trip No. {{ trip.tripId ? trip.tripId : trip.tripNumber }}</span>
                    <b-img-lazy class="img-fluid" :alt="trip.title" :src="getImage(trip)" />
                  </div>
                  <div class="body-tx">
                    <h3>{{ trip.title }}</h3>
                    <p :inner-html.prop="trip.teaser | truncate(350)" class="block-with-text"></p>
                    <router-link class="card-link" :to="trip.page_url ? trip.page_url : '/road-trips/' + trip.slug">Check out this Alabama Road Trip</router-link>
                  </div>
                </article>
              </div>
            </div>
            <router-link class="below-card-link pt-3" :to="{ name: 'road trips', params: { showFeaturedTest: 'passed through router link' } }">View All Road Trips</router-link>
          </div>
          <div class="col-lg-6 col-sm-12 extra-space">
            <div class="d-flex flex-column justify-content-center align-items-center flex-md-row align-content-center mb-4">
              <img src="/images/parks/ART-RoundedIcon.png" alt="" role="presentation" class="img-fluid art-icon mr-3" />
              <h2 class="heading-text">
                Alabama Road Trip <br />
                App for iOS & Android
              </h2>
            </div>
            <div class="row">
              <div class="col-lg-12 app-section-content">
                <div class="d-flex flex-column flex-md-row align-items-center">
                  <div class="p-2 img-right">
                    <b-img-lazy :src="'https://cdn.buttercms.com/YQDKiGnwSPKFPuiZOBmZ'" />
                  </div>
                  <div class="ml-auto p-2">
                    <div class="text-left"><img src="/images/parks/arrow.svg" alt="" role="presentation" class="arrow-icon" /></div>
                    <div v-if="tripIdeasCustomMessage" v-html="tripIdeasCustomMessage" class="info"></div>
                    <div v-else class="info">While you're at it, download the free <b>Alabama Road Trip App</b> to plan and execute your next vacation.</div>
                    <div class="mt-3 more"><router-link to="/apps/alabama-road-trips"> Find out more</router-link></div>
                  </div>
                </div>
                <div class="parks-mt-50">
                  <a href="https://apps.apple.com/us/app/alabama-road-trips/id625261817" target="_blank" rel="noopener noreferrer" class="app-links"
                    ><img src="/images/logos/app-store-logo.png" alt="" role="presentation" class="app-logos mr-3" /></a
                  ><a
                    href="https://play.google.com/store/apps/details?id=com.integrativelogic.roadtrip&feature=search_result#?t=W251bGwsMSwxLDEsImNvbS5pbnRlZ3JhdGl2ZWxvZ2ljLnJvYWR0cmlwIl0"
                    target="_blank" rel="noopener noreferrer"
                    class="app-links"
                    ><img src="/images/logos/google-play-badge.png" alt="" role="presentation" class="app-logos"
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import axios from 'axios';
import { sampleSize } from '../../../store/helpers/helpers';

@Component({
  async mounted() {
    if (this.showRelated) {
      this.trips = this.relatedTrips.slice(0, 3);
    } else {
      await this.loadRandomTripIdeas();
    }

    this.stack = document.querySelector('.stack');
    [...this.stack.children].reverse().forEach(i => this.stack.append(i));
    this.stack.addEventListener('click', this.swap);
  },

  methods: {
    getImage(trip) {
      let returnImage = trip.mainImage;
      if (trip.thumbnailImageUrl) {
        returnImage = trip.thumbnailImageUrl;
      } else if (trip.mainImageUrl) {
        returnImage = trip.mainImageUrl;
      }
      return returnImage;
    },
    swap() {
      const card = document.querySelector('.rt-card:last-child');
      // if (e.target !== card) return;
      card.style.animation = 'swap 700ms forwards';

      setTimeout(() => {
        card.style.animation = '';
        this.stack.prepend(card);
      }, 700);
    },
  },
})
class TripIdeas extends Vue {
  @Watch('relatedTrips', { immediate: false, deep: false })
  async changed() {
    this.trips = this.relatedTrips.slice(0, 3);
  }

  @Prop({
    type: String,
    default: 'Road Trips',
  })
  headerText;

  @Prop({
    type: Boolean,
    default: false,
  })
  showRelated;

  @Prop({
    type: Array,
  })
  relatedTrips;

  @Prop({
    type: String,
  })
  experience;

  @Prop({
    type: String,
  })
  tripIdeasCustomMessage;

  trips = [];

  allTrips = [];

  async loadRandomTripIdeas() {
    if (this.experience) {
      const response = await axios.get(`${process.env.VUE_APP_API2}search_trips?experience=${this.experience}`, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
        },
      });
      if (response && response.data && response.data.trips) {
        this.trips = sampleSize(response.data.trips, 3);
      }
    } else {
      if (!this.$store.state.trips.all || this.$store.state.trips.all.length === 0) {
        await this.$store.dispatch('trips/getAllTrips');
      }
      this.allTrips = this.$store.state.trips.all;
      this.trips = sampleSize(this.allTrips, 3);
    }
  }
}

export default TripIdeas;
</script>

<style lang="scss" scoped>
.block-with-text {
  font-size: 12px;
}
.road-trip-section {
  background-image: url(/images/parks/road-trips-background.jpg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  z-index: 2;
}
.more {
  text-decoration: underline;
  font-size: 20px;
  font-family: 'klinicslabbold';
}
.info {
  color: #173945;
  font-size: 25px;
  font-family: 'klinicslabbold';
}
.arrow-icon {
  width: 100px;
}
article {
  text-align: left;
  padding: 0px;
  margin: 0px;
}
h2 {
  color: #173945;
}
.extra-space {
  margin-top: 75px;
}
.app-section-content {
  margin: 50px 0px;
}
.road-trip-icon {
  width: 75px;
}
.heading-text {
  display: inline-block;
  font-weight: 500;
  font-size: 35px;
  z-index: 1;
}
.app-logos {
  height: 45px;
  margin-top: 50px;
}

.stack {
  width: 500px;
  height: 600px;
  margin: 50px 0px;
  position: relative;
}

.rt-card {
  width: 80%;
  min-height: 420px;
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  cursor: pointer;

  font-family: sans-serif;
  color: #00000080;
  box-shadow: 0 5px 10px 0 #00000040, 0 15px 20px 0#00000020;
  transition: transform 200ms;
  z-index: 2;
}
.trip-number {
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  background-color: #173945;
  padding: 5px 10px;
  position: absolute;
  bottom: 0px;
  left: 15px;
  z-index: 1;
}
.image-wrapper {
  position: relative;
}
.body-tx {
  padding: 25px 20px;
}
.body-tx h3 {
  color: #173945;
}
.card-link {
  color: #173945;
  text-decoration: underline;
  font-family: 'klinicslabBook';
  display: block;
}
.below-card-link {
  padding-left: 20px;
  padding-right: 20px;
  color: #173945;
  text-decoration: underline;
  font-family: 'klinicslabBook';
  display: block;
}
.art-icon {
  max-width: 90px;
  max-height: 90px;
  margin-left: 14px;
}
.parks-mt-50 {
  margin-top: 10px;
}
.app-links {
  display: inline-block;
}
.rt-card:nth-last-child(n + 4) {
  --y: calc(-50% + -30px);
  transform: translate(-50%, var(--y)) scale(0.9);
  box-shadow: 0 0 1px 1px #00000003;
}
.rt-card:nth-last-child(3) {
  --y: calc(-50% + -15px);
  transform: translate(-50%, var(--y)) scale(0.95) rotate(20deg);
}
.rt-card:nth-last-child(2) {
  --y: calc(-50%);
  transform: translate(-50%, var(--y)) scale(1) rotate(10deg);
}
.rt-card:nth-last-child(1) {
  --y: calc(-50% + 15px);
  transform: translate(-50%, var(--y)) scale(1.05) rotate(0deg);
}
@media only screen and (max-width: 1024px) {
  .img-right {
    margin-left: 18px;
  }
}
@media only screen and (max-width: 812px) {
  .img-right {
    margin-left: 0px;
  }
}
@media only screen and (max-width: 768px) {
  .stack {
    width: 380px;
    height: 600px;
    position: relative;
    margin: 20px auto;
  }
  .heading-text {
    font-size: 32px;
  }
  .arrow-icon {
    display: none;
  }
}
@media only screen and (max-width: 400px) {
  .stack {
    width: 305px;
    height: 620px;
    position: relative;
  }
}
</style>

<style>
@keyframes swap {
  50% {
    transform: translate(-50%, calc(var(--y) - 250px)) scale(0.95) rotate(-5deg);
    animation-timing-function: ease-in;
  }
  100% {
    transform: translate(-50%, calc(var(--y) - 15px)) scale(0.95);
    z-index: -1;
  }
}
</style>
